import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

/** Kanban column styling reused by list-view status lozenges (`listStatusConfig`). */
export type KanbanBoardColumnConfig = {
    id: Uuid;
    displayName: string;
    background: string;
    textColor: string;
    possibleValues: Array<string | number | boolean | Uuid>;
    headerBorderRadius?: string;
    headerBorderColor?: string;
    headerBorderWidth?: string;
};

/** System fields allowed in `kanbanBoardCardView` (event cards use the event row; journey cards use the journey row). */
export type KanbanCardSystemFieldId = "createdBy" | "updatedBy" | "createdAt" | "updatedAt";

export const kanbanBoardColumnConfigValidator: zod.ZodType<KanbanBoardColumnConfig> = zod.strictObject({
    id: uuidZodValidator,
    displayName: zod.string(),
    background: zod.string(),
    textColor: zod.string(),
    possibleValues: zod.array(zod.union([zod.string(), zod.number(), zod.boolean()])),
    headerBorderRadius: zod.string().optional(),
    headerBorderColor: zod.string().optional(),
    headerBorderWidth: zod.string().optional(),
});

export const kanbanCardSystemFieldIdValidator: zod.ZodType<KanbanCardSystemFieldId> = zod.enum(["createdBy", "updatedBy", "createdAt", "updatedAt"]);

export function isKanbanCardSystemFieldId(id: unknown): id is KanbanCardSystemFieldId {
    return id === "createdBy" || id === "updatedBy" || id === "createdAt" || id === "updatedAt";
}
